<template>
    <div class="animated efficiency">
        <div class="container-fluid">
            <ProductTabs></ProductTabs>
            <div class="statistic-wrap">
                <StatisticTable :headColumns="headColumns"
                                :title="`${$t('pages.by_category_product')}`"
                                :rows="storageCountries"
                                :isFixed="true">

                </StatisticTable>
            </div>
        </div>
    </div>
</template>

<script>
  import API from '../../../api/API'
  import {map, find, max} from 'lodash'
  import ProductTabs from './ProductTabs.vue'
  import StatisticTable from '../../../components/StatisticTable.vue'
  import Helper from '../../../api/Helper'
  import TypeColor from '../../../assets/TypeColor'

  export default {
    name: 'ProductTag',
    components: {ProductTabs, StatisticTable},
    data () {
      return {
        data: [],
        allTags: {},
        statistic: {},
        countries: {},
        Helper: Helper,
        Storage: Storage,
        TypeColor: TypeColor,
        storageCountries: [],
        isLoading: false,
        headColumns: [
          {label: this.$root.$t('statistic.country'), field: 'country', field_country: true, fix: true},
          {label: this.$root.$t('statistic.adult'), field: 'adult', fix: true},
          {label: this.$root.$t('statistic.slimming'), field: 'slimming', fix: true},
          {label: this.$root.$t('statistic.beauty'), field: 'beauty', fix: true},
          {label: this.$root.$t('statistic.health'), field: 'health', fix: true},
          {label: this.$root.$t('statistic.economizers'), field: 'economizers', fix: true},
          {label: this.$root.$t('statistic.lowPrice'), field: 'lowPrice', fix: true},
          {label: this.$root.$t('statistic.hair'), field: 'hair', fix: true},
          {label: this.$root.$t('statistic.sport'), field: 'sport', fix: true},
          {label: this.$root.$t('statistic.other'), field: 'other', fix: true}
        ]
      }
    },
    mounted () {
      this.getTags()
      this.getCountries()
      this.$root.$on('filters_load_new_data', () => {
        this.getTags()
      })
    },
    methods: {
      getCountries () {
        API.getCountries()
          .then(response => {
            Storage.countries = response.body
          })
          .catch(response => {
            this.$notify({
              type: 'danger',
              title: this.$root.$t('verbs.error'),
              text: !response.body.message ? response.body : response.body.message,
              animationType: 'velocity'
            })
          })
      },
      getTags () {
        this.$root.$emit('data_loading')
        let datat
        this.storageCountries = []
        API.getProductTags()
          .then(response => {
            datat = response.body
            this.statistic = response.body.statistic
            this.allTags = datat.tags
            this.$root.$emit('data_loaded')
            let totalAdult = []
            let totalSlimming = []
            let totalBeauty = []
            let totalHealth = []
            let totalEconomizers = []
            let totallowPrice = []
            let totalHair = []
            let totalSport = []
            let totalOther = []
            for (let i in response.body.statistic) {
              for (let o in response.body.statistic[i]) {
                if (o === '1') {
                  find(response.body.statistic[i][1], function (i) {
                    return totalAdult.push(i)
                  })
                } else if (o === '2') {
                  find(response.body.statistic[i][2], function (i) {
                    return totalSlimming.push(i)
                  })
                } else if (o === '3') {
                  find(response.body.statistic[i][3], function (i) {
                    return totalBeauty.push(i)
                  })
                } else if (o === '4') {
                  find(response.body.statistic[i][4], function (i) {
                    return totalHealth.push(i)
                  })
                } else if (o === '5') {
                  find(response.body.statistic[i][5], function (i) {
                    return totalEconomizers.push(i)
                  })
                } else if (o === '6') {
                  find(response.body.statistic[i][6], function (i) {
                    return totallowPrice.push(i)
                  })
                } else if (o === '7') {
                  find(response.body.statistic[i][7], function (i) {
                    return totalHair.push(i)
                  })
                } else if (o === '8') {
                  find(response.body.statistic[i][8], function (i) {
                    return totalSport.push(i)
                  })
                } else if (o === '9') {
                  find(response.body.statistic[i][9], function (i) {
                    return totalOther.push(i)
                  })
                }
              }
            }
            map(Object.keys(response.body.statistic), (i) => {
              let country = find(Storage.countries, {id: parseInt(i)})
              if (country !== undefined) {
                let adult = response.body.statistic[country.id][1]
                let slimming = response.body.statistic[country.id][2]
                let beauty = response.body.statistic[country.id][3]
                let health = response.body.statistic[country.id][4]
                let economizers = response.body.statistic[country.id][5]
                let lowPrice = response.body.statistic[country.id][6]
                let hair = response.body.statistic[country.id][7]
                let sport = response.body.statistic[country.id][8]
                let other = response.body.statistic[country.id][9]
                this.storageCountries.push({
                  country: {
                    value: country.name,
                    code: country.code
                  },
                  adult: {
                    value: adult,
                    bgg: (parseInt(adult) / max(totalAdult) * 100)
                  },
                  slimming: {
                    value: slimming,
                    bgg: (parseInt(slimming) / max(totalSlimming) * 100)
                  },
                  beauty: {
                    value: beauty,
                    bgg: (parseInt(beauty) / max(totalBeauty) * 100)
                  },
                  health: {
                    value: health,
                    bgg: (parseInt(health) / max(totalHealth) * 100)
                  },
                  economizers: {
                    value: economizers,
                    bgg: (parseInt(economizers) / max(totalEconomizers) * 100)
                  },
                  lowPrice: {
                    value: lowPrice,
                    bgg: (parseInt(lowPrice) / max(totallowPrice) * 100)
                  },
                  hair: {
                    value: hair,
                    bgg: (parseInt(hair) / max(totalHair) * 100)
                  },
                  sport: {
                    value: sport,
                    bgg: (parseInt(sport) / max(totalSport) * 100)
                  },
                  other: {
                    value: other,
                    bgg: (parseInt(other) / max(totalOther) * 100)
                  }
                })
              }
            })
            this.$root.$emit('data_loaded')
          })
          .catch(response => {
            this.$root.$emit('data_loaded')
            this.$notify({
              type: 'danger',
              title: this.$root.$t('verbs.error'),
              text: !response.body ? response.body : response.body.message,
              animationType: 'velocity'
            })
          })
      }
    }
  }
</script>

<style scoped>
    .card-header {
        font-size: 1.5rem;
        text-align: center;
    }
    .container-fluid {
        padding: 0;
    }
    .option__image {
        vertical-align: middle;
    }
    .flag {
        margin: 0 auto;
        padding: 0;
    }
</style>



// WEBPACK FOOTER //
// ProductTag.vue?0070260c